import { render, staticRenderFns } from "./DateChooser.vue?vue&type=template&id=c2eff2bc"
import script from "./DateChooser.vue?vue&type=script&lang=js"
export * from "./DateChooser.vue?vue&type=script&lang=js"
import style0 from "./DateChooser.vue?vue&type=style&index=0&id=c2eff2bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports